import type { Action, ThunkAction } from '@reduxjs/toolkit'
import { combineReducers, configureStore, Tuple } from '@reduxjs/toolkit'
import { thunk } from 'redux-thunk'

// Route reducers
import user from './user/reducer'
import cities from './cities/reducer'
import app from './app/reducer'
import requests from './requests/reducer'
import applicant from './applicant/reducer'
import password from './password/reducer'
import sourceRequest from './sourceRequest'

import type { TypedUseSelectorHook } from 'react-redux'
import { useDispatch, useSelector } from 'react-redux'

const rootReducer = combineReducers({
  user,
  cities,
  app,
  requests,
  applicant,
  sourceRequest,
  password
})

export type AppState = ReturnType<typeof rootReducer>

export const createStore = (preloadedState?: Partial<AppState>) =>
  configureStore({
    reducer: rootReducer,
    middleware: () => new Tuple(thunk),
    preloadedState
  })

export const store = createStore()

export type AppDispatch = typeof store.dispatch

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action<string>>

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector

export default store
